import * as api from "../apis/callToActionsApi";
import {
  useQuery,
  useQueryClient,
  queryOptions,
  useSuspenseQuery,
} from "@tanstack/react-query";


// Query options

export const getCallToActionsQueryOptions = () => {
  return queryOptions({
    queryKey: ["callToActions"],
    queryFn: api.getCallToActions,
    refetchOnWindowFocus: "always",
    
  });
};

export const getCallToActionsByAdPlatformQueryOptions = (
  adPlatformId,
  queryClient
) =>
  queryOptions({
    queryKey: ["adPlatform.callToActions", adPlatformId],
    queryFn: () => api.getCallToActionsByAdPlatform(adPlatformId),
    refetchOnWindowFocus: "always",
    
    initialData: () =>
      queryClient
        .getQueryData(["callToActions"])
        ?.filter((callToAction) => callToAction.adPlatform?.id === adPlatformId),
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(["callToActions"])?.dataUpdatedAt,
  });

export const getCallToActionQueryOptions = (id, queryClient) => {
  let queryKey;

  return queryOptions({
    queryKey: ["callToAction", id],
    queryFn: () => api.getCallToAction(id),
    refetchOnWindowFocus: "always",
    
    initialData: () => {
      // if "callToActions" query exist, we use it to init data
      if (queryClient.getQueryState(["callToActions"])) {
        queryKey = ["callToActions"];
        return queryClient
          .getQueryData(["callToActions"])
          ?.find((callToAction) => callToAction.id === id);
      }

      // otherwise, we try to find the callToAction in one of the "adPlatform.callToActions" queries
      let found;

      queryClient
        .getQueriesData({ queryKey: ["adPlatform.callToActions"] })
        .forEach((query) => {
          const data = query[1];
          data.forEach((callToAction) => {
            if (callToAction.id === id) {
              found = callToAction;
              queryKey = query[0];
            }
          });
        });

      return found;
    },
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
};

// useQuery

export const useGetCallToActions = () => useQuery(getCallToActionsQueryOptions());

export const useGetCallToAction = (id) => {
  const queryClient = useQueryClient();
  return useQuery(getCallToActionQueryOptions(id, queryClient));
};

// useSuspenseQuery

export const useSuspenseGetCallToActions = () => {
  return useSuspenseQuery(getCallToActionsQueryOptions());
};

export const useSuspenseGetCallToActionsByAdPlatform = (adPlatformId) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(
    getCallToActionsByAdPlatformQueryOptions(adPlatformId, queryClient)
  );
};

export const useSuspenseGetCallToAction = (id) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(getCallToActionQueryOptions(id, queryClient));
};
